:host {
  display: block;
}

.legrandav-textinput-default-m-wrapper {
  display: flex;
  flex-direction: column;
}

label {
  color: #545454;
  font-size: 16px;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  font-weight: normal;
  letter-spacing: 0.2px;
  line-height: 24px;
}

input {
  width: 100%;
  max-height: 48px;
  border: 1px solid rgb(168, 168, 168);
  border-radius: 0px;
  color: rgb(38, 38, 38);
  font-size: 20px;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  font-weight: normal;
  letter-spacing: 0px;
  line-height: 30px;
  padding: 8px 16px;
}

.legrandav-textinput-default-m-wrapper-Error-State input {
  border: 1px solid rgb(204, 0, 0);
}

::placeholder {
  color: #a8a8a8;
}

.error-message {
  color: rgb(204, 0, 0);
  font-size: 12px;
  font-family: 'acumin-pro', Helvetica, Arial, sans-serif;
  font-weight: 500;
  letter-spacing: 0.6px;
  line-height: 18px;
}
